module.exports = __webpack_public_path__ + "static/media/om-drawer-mf-ikon@3x.aca7bcab.png";